import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import React, { CSSProperties, FC } from 'react'

import { Button } from './Button'
import { LinkContainer } from './common.components'
import { Size } from './common.types'

interface Props {
    customClass?: string
    href?: string
    iconLeft?: IconDefinition
    iconRight?: IconDefinition
    isDisabled?: boolean
    isLoading?: boolean
    onClick?: (event?: React.MouseEvent) => void
    reloadPage?: boolean
    size?: Size
    style?: CSSProperties
    text?: string
}

export const LinkButton: FC<Props> = (props) => {
    return (
        <LinkContainer isDisabled={props.isDisabled}>
            <Button {...props} type={'link'} target={'_self'}/>
        </LinkContainer>
    )
}

LinkButton.defaultProps = {
    customClass: undefined,
    size: 'large',
    href: undefined,
    onClick: undefined,
    style: undefined,
    isDisabled: false,
    isLoading: false,
    text: undefined,
}
